import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Login.css";
import oxfordLogo from "../media/oxford-logo-long.svg";
import ToolTip from "../components/component-tools/ToolTip";

const Register = () => {
  const [portal, setPortal] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const successMessage = location.state?.successMessage;
  const failMessage = location.state?.failMessage;

  useEffect(() => {
    const storedPortal = localStorage.getItem("portalType");

    if (storedPortal) {
      setPortal(storedPortal);
    }
  }, []);

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => setErrorMessage(""), 3000);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleNavigation();
    }
  };

  const handleNavigation = async () => {
    if (!portal) {
      setErrorMessage("Please select a portal.");
      return;
    }

    if (portal === "client") {
      navigate("/client/registration");
    } else if (portal === "candidate") {
      navigate("/candidate/registration");
    }
  };

  return (
    <div
      className="content-container-login"
      onKeyDown={handleKeyDown}
      tabIndex={0}
    >
      <div className="login-container">
        <div className="mobile-warning">
          For the best experience, we recommend using a computer to use this
          application.
        </div>
        <div className="logo-help-wrapper">
          <img className="oxford-logo-long" src={oxfordLogo} alt="Logo" />
          <button
            className="help-icon-button"
            onClick={() => navigate("/help")}
            aria-label="Help"
          >
            <i className="bi bi-question-circle"></i>
          </button>
        </div>
        <h1>Register</h1>

        <div className="portal-selection">
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              height: "30px",
            }}
          >
            <input
              type="radio"
              value="client"
              checked={portal === "client"}
              onChange={() => setPortal("client")}
            />{" "}
            <span>Client</span>
            <ToolTip
              tooltipText="The organization requesting background checks."
              placement="right"
              className="info-icon-spec"
            ></ToolTip>
          </label>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              height: "30px",
            }}
          >
            <input
              type="radio"
              value="candidate"
              checked={portal === "candidate"}
              onChange={() => setPortal("candidate")}
            />{" "}
            <span>Candidate</span>
            <ToolTip
              tooltipText="The individual being screened for the organization."
              placement="right"
              className="info-icon-spec"
            ></ToolTip>
          </label>
        </div>

        <button
          onClick={handleNavigation}
          type="button"
          className={`oxbtn ${portal !== "" ? "btn-purple" : "btn-login"}`}
        >
          Go to Registration
        </button>
        <div>
          {successMessage && (
            <div className=" alert alert-success fade show">
              {successMessage}
            </div>
          )}
          {failMessage && (
            <div className=" alert alert-danger fade show">{failMessage}</div>
          )}
        </div>
        <div>
          <a href="/login">Already have an account? Click here.</a>
        </div>
        {/* <div className="pop-up-warning">
          ⚠️ Application maintenance is in progress.  You can continue to use
          the application but may experience slower performance during this
          time.
        </div> */}
        {/* <div className="pop-up-error">
          🚫 We’re performing a scheduled update. Please try again later.
        </div> */}
        <div className="text-container-login" style={{ textAlign: "center" }}>
          {" "}
        </div>
      </div>

      {errorMessage && (
        <div className="alert-message alert alert-danger alert-dismissible fade show">
          {errorMessage}
          <button
            type="button"
            className="btn-close"
            onClick={() => setErrorMessage("")}
            aria-label="Close"
          ></button>
        </div>
      )}
    </div>
  );
};

export default Register;
